import { createContext } from 'react';
// import { useStateManager } from '../hooks/useStateManager';

const defaultState: any = [];

const TodoContext = createContext(defaultState);

export default TodoContext;
